/* global Config */

import {isCancel, request} from 'axios';
import {isArray, isPlainObject, join} from 'lodash';
import uuid from 'uuid';

// Utils
import {cleanObject} from './object';

const getError = (type, error) => `There was a problem with the ${type}: ${error}`;
const triggerAuthentication = () => {
    window.location.href = `${Config.oauth.oauthBaseUrl}${Config.oauth.authorizationUrl}?${new URLSearchParams({
        client_id: Config.oauth.clientId,
        redirect_uri: Config.oauth.redirectUrl,
        response_type: 'code',
        scope: ['user_info'],
        state: uuid.v4(),
    }).toString()}`;
};
const serviceCaller = (serviceParams, ajaxParams) => {
    const {dispatchCancel, dispatchFetched, dispatchError} = serviceParams;

    if (ajaxParams.timeout === undefined) {
        ajaxParams.timeout = 120000;
    }

    return request(ajaxParams)
        .then(response => {
            const data = cleanObject(response.data) || {};
            const {error} = data;

            if (error) {
                dispatchError(getError('response', isPlainObject(error) ? JSON.stringify(error) : error), response);
            } else {
                dispatchFetched(data, response);
            }
        })
        .catch(error => {
            const {message, response} = error;
            let errorText;
            let unauthorized = false;

            if (!isCancel(error)) {
                if (response) {
                    const {data, status, statusText} = response;

                    unauthorized = status === 401;

                    if (data && data.error) {
                        errorText = data.error;
                    } else if (unauthorized) {
                        errorText = 'Unauthorized';
                    } else if (data && isArray(data) && data.length > 0) {
                        errorText = join(data, '. ');
                    } else if (statusText && statusText !== 'error') {
                        errorText = statusText;
                    } else if (message && message !== 'error') {
                        errorText = message;
                    }

                    errorText += `.  Status code: ${status}.`;
                } else if (message && message !== 'error') {
                    errorText = message;
                } else {
                    errorText = 'An unknown error has occurred';
                }

                if (Config.base.env === 'development') {
                    console.error(error);
                }

                dispatchError(getError('request', errorText), error);

                if (unauthorized) {
                    triggerAuthentication();
                }
            } else if (dispatchCancel) {
                dispatchCancel(error);
            }
        });
};

export default serviceCaller;
